import React from 'react';

interface QuickActionCardProps {
  icon: string;
  label: string;
  onClick?: () => void;
  iconWidth?: string;
  disable?: boolean;
}

const QuickActionCard: React.FC<QuickActionCardProps> = ({
  icon,
  label,
  onClick,
  disable,
  iconWidth = "100%"
}) => {
  return (
    <>
      {!disable ?
        <div
          onClick={onClick}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '100px',
            minHeight: '89px',
            border: "1px solid #f4f3f4",
            background: "#fafafa",
            borderRadius: "10px",
            justifyContent: "space-evenly",
            padding: "10px",
            cursor: onClick ? 'pointer' : 'default'
          }}
        >
          <div style={{
            width: '35px',
            height: '35px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '4px'
          }}>
            <img style={{ width: iconWidth, height: '35px', objectFit: 'contain' }} src={icon} alt={label} />
          </div>
          <span style={{
            fontSize: '12px',
            lineHeight: '14px',
            fontWeight: 700,
            color: '#393939',
            textAlign: 'center'
          }}>
            {label}
          </span>
        </div>
        :
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '100px',
            minHeight: '89px',
            border: "1px solid #f4f3f4",
            background: "#fafafa",
            borderRadius: "10px",
            justifyContent: "space-evenly",
            padding: "10px",
            pointerEvents: 'none',
            position: 'relative'
          }}
        >
          <span
            style={{
              position: 'absolute', top: '0px',
              right: '0px',
              background: '#dc3545',
              color: '#fff',
              fontSize: '6px',
              fontWeight: 700,
              padding: '2px 5px',
              borderRadius: '10px',
              textTransform: 'uppercase',
              pointerEvents: 'none'
            }}
          >Coming Soon</span>
          <div style={{
            width: '35px',
            height: '35px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '4px'
          }}>
            <img style={{
              width: iconWidth, height: '35px', objectFit: 'contain', filter: "grayscale(100%) brightness(100%)",
              opacity: '0.4'
            }} src={icon} alt={label} />
          </div>
          <span style={{
            fontSize: '12px',
            lineHeight: '14px',
            fontWeight: 700,
            color: '#ababab',
            textAlign: 'center'
          }}>
            {label}
          </span>
        </div>}
    </>
  );
};

export default QuickActionCard;

